import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import { emiratesId_Request } from "../../../../store/actions";
import { IKIOSKModel, IkioskMenuIds } from "../../../../models/kioskModel2";
import emiratescard from '../../../../images/emirates-card.svg';
import { Ilanguages } from "../../../../models/utilitiesModel";
let subscribe;

const EmiratesIdVerification: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("translations");
  const language: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.language || Ilanguages.ENG) ;
  const menutype: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.selectedPage || IkioskMenuIds.LOGINPAGE);
  useEffect(() => {
    if (menutype === IkioskMenuIds.INSERTEMIRATESID) {
      subscribe = setTimeout(() => {
        dispatch(emiratesId_Request());
      }, 5000);
    }
    return () => {
      clearTimeout(subscribe);
    }
  }, [dispatch,menutype]);
  return (
    <div className="kiosk-content">
      <div className="content-sec w70 text-center verfcontent">
        <img src={emiratescard} width="210" alt="" />
        <div style={{ marginLeft: "50px" }}>
          <h1 style={{ marginBottom: "20px" }}>{t('kiosktranslation.emiratesID' + language)}</h1>
        </div>
      </div>
    </div>
  )
}
export default React.memo(EmiratesIdVerification);